import { Loader2, Check, AlertTriangle } from "lucide-react"
import { TOOL_LABELS } from "@/lib/ai-types"
import type { RichToolCall } from "@/lib/ag-ui-types"

function parseActionDesc(toolCall: RichToolCall): string {
  const label = TOOL_LABELS[toolCall.name] || toolCall.name
  try {
    const args = JSON.parse(toolCall.args)
    const name = args.name || args.title || args.subject || ""
    return name ? `${label}: ${name}` : label
  } catch {
    return label
  }
}

function isError(result: string | null): boolean {
  if (!result) return false
  try {
    const parsed = JSON.parse(result)
    return !!parsed.error
  } catch {
    return false
  }
}

export function ActionCard({ toolCall }: { toolCall: RichToolCall }) {
  const description = parseActionDesc(toolCall)
  const isDone = toolCall.status === "done"
  const error = isDone && isError(toolCall.result)

  return (
    <div
      className="my-2 flex items-center gap-2.5 rounded-lg px-3 py-2"
      style={{ border: "1px solid var(--border)", background: "var(--bg-surface)" }}
    >
      {!isDone && <Loader2 size={14} className="animate-spin" style={{ color: "var(--primary)" }} />}
      {isDone && !error && <Check size={14} style={{ color: "var(--color-success)" }} />}
      {isDone && error && <AlertTriangle size={14} style={{ color: "var(--color-error)" }} />}
      <span className="flex-1 text-xs" style={{ color: "var(--text-primary)" }}>{description}</span>
      {isDone && !error && (
        <span className="text-[10px]" style={{ color: "var(--color-success)" }}>Gotowe</span>
      )}
      {isDone && error && (
        <span className="text-[10px]" style={{ color: "var(--color-error)" }}>Błąd</span>
      )}
    </div>
  )
}
